import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_PAYMENT_PORTAL_PREFERENCES_REQUEST = 'FETCH_PAYMENT_PORTAL_PREFERENCES_REQUEST';
export const FETCH_PAYMENT_PORTAL_PREFERENCES_SUCCESS = 'FETCH_PAYMENT_PORTAL_PREFERENCES_SUCCESS';
export const FETCH_PAYMENT_PORTAL_PREFERENCES_FAILURE = 'FETCH_PAYMENT_PORTAL_PREFERENCES_FAILURE';

export const UPDATE_PAYMENT_PORTAL_PREFERENCES_REQUEST = 'UPDATE_PAYMENT_PORTAL_PREFERENCES_REQUEST';
export const UPDATE_PAYMENT_PORTAL_PREFERENCES_SUCCESS = 'UPDATE_PAYMENT_PORTAL_PREFERENCES_SUCCESS';
export const UPDATE_PAYMENT_PORTAL_PREFERENCES_FAILURE = 'UPDATE_PAYMENT_PORTAL_PREFERENCES_FAILURE';

export const PAYMENT_PORTAL_CONFIG_REQUEST = 'PAYMENT_PORTAL_CONFIG_REQUEST';
export const PAYMENT_PORTAL_CONFIG_SUCCESS = 'PAYMENT_PORTAL_CONFIG_SUCCESS';
export const PAYMENT_PORTAL_CONFIG_FAILURE = 'PAYMENT_PORTAL_CONFIG_FAILURE';

export const PAYMENT_PORTAL_TRANSACTION_LISTING_REQUEST = 'PAYMENT_PORTAL_TRANSACTION_LISTING_REQUEST';
export const PAYMENT_PORTAL_TRANSACTION_LISTING_SUCCESS = 'PAYMENT_PORTAL_TRANSACTION_LISTING_SUCCESS';
export const PAYMENT_PORTAL_TRANSACTION_LISTING_FAILURE = 'PAYMENT_PORTAL_TRANSACTION_LISTING_FAILURE';

export const FETCH_PAYMENT_PORTAL_JWT_TOKEN_REQUEST = 'FETCH_PAYMENT_PORTAL_JWT_TOKEN_REQUEST';
export const FETCH_PAYMENT_PORTAL_JWT_TOKEN_SUCCESS = 'FETCH_PAYMENT_PORTAL_JWT_TOKEN_SUCCESS';
export const FETCH_PAYMENT_PORTAL_JWT_TOKEN_FAILURE = 'FETCH_PAYMENT_PORTAL_JWT_TOKEN_FAILURE';

export const HOSTED_PAYMENT_PAGE_TOKEN_REQUEST = 'HOSTED_PAYMENT_PAGE_TOKEN_REQUEST';
export const HOSTED_PAYMENT_PAGE_TOKEN_SUCCESS = 'HOSTED_PAYMENT_PAGE_TOKEN_SUCCESS';
export const HOSTED_PAYMENT_PAGE_TOKEN_FAILURE = 'HOSTED_PAYMENT_PAGE_TOKEN_FAILURE';

const baseURL = 'payment-portal';
const baseURLPreference = 'payment-portal-preferences';

export const fetchPaymentPortalPreferences = () => ({
  [CALL_API]: {
    endpoint: baseURLPreference,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_PAYMENT_PORTAL_PREFERENCES_REQUEST,
      FETCH_PAYMENT_PORTAL_PREFERENCES_SUCCESS,
      FETCH_PAYMENT_PORTAL_PREFERENCES_FAILURE,
    ],
  },
});

export const updatePaymentPortalPreferences = (updatedPreferences: IPaymentPortalPrefrencesRequest) => ({
  [CALL_API]: {
    endpoint: baseURLPreference,
    method: 'put',
    body: updatedPreferences,
    authenticated: true,
    types: [
      UPDATE_PAYMENT_PORTAL_PREFERENCES_REQUEST,
      UPDATE_PAYMENT_PORTAL_PREFERENCES_SUCCESS,
      UPDATE_PAYMENT_PORTAL_PREFERENCES_FAILURE,
    ],
  },
});

export const getPaymentPortalConfig = (token: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${token}/config`,
    method: 'get',
    authenticated: false,
    types: [PAYMENT_PORTAL_CONFIG_REQUEST, PAYMENT_PORTAL_CONFIG_SUCCESS, PAYMENT_PORTAL_CONFIG_FAILURE],
  },
});

export const getPaymentPortalJWTToken = (
  token: string,
  paymentPortalJWTTokenRequest: IPaymentPortalJWTTokenRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${token}/search`,
    method: 'post',
    body: paymentPortalJWTTokenRequest,
    authenticated: false,
    types: [
      FETCH_PAYMENT_PORTAL_JWT_TOKEN_REQUEST,
      FETCH_PAYMENT_PORTAL_JWT_TOKEN_SUCCESS,
      FETCH_PAYMENT_PORTAL_JWT_TOKEN_FAILURE,
    ],
  },
});

export const getPaymentPortalTransactionListing = (paymentPortalJWTToken: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/transaction-listing`,
    method: 'get',
    authenticated: false,
    headers: { Authorization: `Bearer ${paymentPortalJWTToken}` },
    types: [
      PAYMENT_PORTAL_TRANSACTION_LISTING_REQUEST,
      PAYMENT_PORTAL_TRANSACTION_LISTING_SUCCESS,
      PAYMENT_PORTAL_TRANSACTION_LISTING_FAILURE,
    ],
  },
});

export const getHostedPaymentPageToken = (paymentPortalJWTToken: string, pageRequest: IHosetedPaymentPageRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/payment-form-token`,
    method: 'post',
    authenticated: false,
    headers: { Authorization: `Bearer ${paymentPortalJWTToken}` },
    body: pageRequest,
    types: [HOSTED_PAYMENT_PAGE_TOKEN_REQUEST, HOSTED_PAYMENT_PAGE_TOKEN_SUCCESS, HOSTED_PAYMENT_PAGE_TOKEN_FAILURE],
  },
});
